import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  deleteAdjacentHub,
  getAdjacentHubList,
  GetAdjacentHubListRequestType,
} from 'features/Location/services/adjacentHub'
import { toastFailed, toastSuccess } from 'utils/toast'
import { toAdjacentLocationNameMap } from 'features/Location/utils/adjacentHub'
import {
  SLICE_NAME,
  setIsLoading,
  setList,
  setAdjacentLocationNames,
  setDeleteTarget,
  setIsDeleting,
} from './slice'

export const fetchAdjacentHubList = createAsyncThunk(
  `${SLICE_NAME}/fetchAdjacentHubList`,
  async (_, { dispatch, rejectWithValue, getState }) => {
    const {
      adjacentHubList: { query },
    } = getState() as StoreStateType
    dispatch(setIsLoading(true))

    const params: GetAdjacentHubListRequestType['params'] = {
      page: query.page_index + 1,
      limit: query.page_size,
      ...(query.status !== 'ALL' ? { status: query.status === 'ACTIVE' } : {}),
      ...(query.search_value ? { [query.search_by]: query.search_value } : {}),
    }

    try {
      const { data } = await getAdjacentHubList({ params })
      dispatch(setList(data.data.adjacent))
      dispatch(setIsLoading(false))
      // Names now come with the list; cache them for the edit dialog and Global Scheduled Close.
      dispatch(
        setAdjacentLocationNames(
          toAdjacentLocationNameMap(data.data.adjacent.flatMap((item) => item.adjacent_location)),
        ),
      )

      return data
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoading(false))
      return rejectWithValue(error)
    }
  },
)

export const removeAdjacentHub = createAsyncThunk(
  `${SLICE_NAME}/removeAdjacentHub`,
  async (_, { dispatch, getState, rejectWithValue }) => {
    const {
      adjacentHubList: { deleteTarget },
    } = getState() as StoreStateType
    if (!deleteTarget) return rejectWithValue('nothing to delete')

    dispatch(setIsDeleting(true))
    try {
      const { data } = await deleteAdjacentHub(deleteTarget.location_id)
      if (data.error?.status) {
        toastFailed(data.error.message)
        dispatch(setIsDeleting(false))
        return rejectWithValue(data.error)
      }

      toastSuccess(data.data.message)
      dispatch(setDeleteTarget(null))
      dispatch(setIsDeleting(false))
      dispatch(fetchAdjacentHubList())
      return data
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsDeleting(false))
      return rejectWithValue(error)
    }
  },
)
